import { writable } from "svelte/store";

/**
 * True when the local player has the "ezInvisible" player variable set (invisibility potion).
 * Remote clients hide the character entirely; the local client renders it semi-transparent
 * so the player can still see where they are.
 */
export const ezInvisibleStore = writable(false);
